// hooks/API/GET/useReorderCategoryList.js

import { useQuery } from 'react-query';
import { useContext } from 'react';
import { FetchContext } from 'context/FetchContext';

function useReorderCategoryList(data = {}) {
  const { enabled = true, queryKey = ['podcast-reorder-category'] } = data;
  const { privateFetch } = useContext(FetchContext);

  const fetchReorderCategories = () => privateFetch.get('/v1/admin/podcast/categories/reorder');

  return useQuery(queryKey, fetchReorderCategories, {
    enabled,
    keepPreviousData: false, // Change to false
    cacheTime: 0, // Add this to prevent caching
    staleTime: 0, // Add this to always fetch fresh data
    select: (res) => res?.data?.data || [],
  });
}

export default useReorderCategoryList;
